import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireAuth } from './CheckedAuthRoute';
import { AppRoute, AppRoutes } from './AppRoutes';
import Settings from '../settings/containers/Settings';
import AuthContainer from '../auth/containters/authContainer';
import ProgramDeepLink from '../program/containers/ProgramDeepLink';
import { Recommendations } from '../recommendations/containers/Recommendations';
import NotFound from './NotFound';
import { GrowegyAI } from '../growegy-ai/containers/GrowegyAI';
import { businessPlanConfig, marketplaceConfig, readCommonConfig } from '../commons/config';
import { RedirectToUrl } from '../commons/components/RedirectToUrl';
import PlanningTabs from '../program/containers/PlanningTabs';
import { BusinessPlan } from '../businessplan/containers/BusinessPlan';
import React from 'react';
import { Marketplace } from '../marketplace/containers/Marketplace';
import useAuth from '../auth/authContext';
import { Permission } from '../auth/permissions';
import { HelpMenu } from '../help/components/HelpMenu';
import { DividerIcon, QuestionMarkIcon } from '../assets/icons';
import { StyleVariables } from '../commons/styleConstants';
import { Funding } from '../funding/containers/Funding';
import { Tooltip } from 'react-tooltip';
import { YouTubeTutorialButton } from '../youtube-tutorials/components/YouTubeTutorialButton';

export default function AppRouter() {
  const commonConfig = readCommonConfig();
  const {
    state: { user },
  } = useAuth();

  return (
    <div className="app-main">
      <Routes>
        <Route
          path={AppRoutes.Home}
          element={
            <RequireAuth path={AppRoutes.Home}>
              {user?.has(Permission.USE_CHAT_GPT) ? <GrowegyAI /> : <PlanningTabs />}
            </RequireAuth>
          }
        />
        <Route
          path={AppRoutes.Calendar}
          element={
            <RequireAuth path={AppRoutes.Calendar}>
              <PlanningTabs />
            </RequireAuth>
          }
        />
        {businessPlanConfig.enabled ? (
          <Route
            path={AppRoutes.BusinessPlan}
            element={
              <RequireAuth path={AppRoute.businessPlan}>
                {user?.has(Permission.BUSINESS_PLAN) ? <BusinessPlan /> : null}
              </RequireAuth>
            }
          />
        ) : (
          <></>
        )}
        {marketplaceConfig.enabled ? (
          <Route
            path={AppRoutes.Marketplace}
            element={
              <RequireAuth path={AppRoute.marketplace}>
                <Marketplace />
              </RequireAuth>
            }
          />
        ) : (
          <></>
        )}
        <Route
          path={AppRoutes.Program.deeplink}
          element={
            <RequireAuth path={AppRoutes.Program.deeplink}>
              <ProgramDeepLink />
            </RequireAuth>
          }
        />
        <Route
          path={AppRoutes.GrowegyAI}
          element={
            <RequireAuth path={AppRoutes.GrowegyAI}>
              {user?.has(Permission.USE_CHAT_GPT) ? <GrowegyAI /> : null}
            </RequireAuth>
          }
        />
        <Route
          path={AppRoutes.Funding}
          element={
            <RequireAuth path={AppRoutes.Funding}>
              {user?.has(Permission.CHANGE_BILLING) ? <Funding /> : null}
            </RequireAuth>
          }
        />
        <Route
          path={AppRoutes.Recommendations}
          element={
            <RequireAuth path={AppRoutes.Recommendations}>
              <Recommendations />
            </RequireAuth>
          }
        />
        <Route
          path={AppRoutes.Settings}
          element={
            <RequireAuth path={AppRoutes.Settings}>
              <Settings />
            </RequireAuth>
          }
        />
        <Route
          path={AppRoutes.Billing}
          element={
            <RequireAuth path={AppRoutes.Billing}>
              <Settings />
            </RequireAuth>
          }
        />
        <Route
          path={AppRoutes.Auth.signIn}
          element={
            <RequireAuth path={AppRoutes.Auth.signIn}>
              <AuthContainer tab="SIGN_IN" />
            </RequireAuth>
          }
        />
        <Route
          path={AppRoutes.Auth.signUp}
          element={
            <RequireAuth path={AppRoutes.Auth.signUp}>
              {commonConfig.inAppSignup ? (
                <AuthContainer tab="SIGN_UP" />
              ) : commonConfig.externalSignupUrl ? (
                <RedirectToUrl url={commonConfig.externalSignupUrl} />
              ) : (
                <></>
              )}
            </RequireAuth>
          }
        />
        <Route
          path={AppRoutes.Auth.signOut}
          element={
            <RequireAuth path={AppRoutes.Auth.signOut}>
              <Navigate
                to={{
                  pathname: AppRoutes.Home,
                }}
              />
            </RequireAuth>
          }
        />
        <Route
          path={AppRoutes.NotFound}
          element={
            <RequireAuth path={AppRoutes.NotFound}>
              <NotFound />
            </RequireAuth>
          }
        />
        <Route
          path="*"
          element={
            <Navigate
              to={{
                pathname: AppRoutes.NotFound,
              }}
              state={{}}
            />
          }
        />
      </Routes>
      <div className="app-main__help-menu-container">
        <YouTubeTutorialButton />
        <div className="app-main__help-menu-divider">
          <DividerIcon />
        </div>
        <div className="m-auto">
          <HelpMenu
            customToggle={() => (
              <>
                <div
                  data-tooltip-id="app-router__help-menu"
                  data-tooltip-place="bottom"
                  className="d-flex"
                >
                  <QuestionMarkIcon fill={StyleVariables.neutral500} />
                </div>
                <Tooltip
                  id="app-router__help-menu"
                  className="info-button__tooltip"
                  noArrow={true}
                  place="bottom"
                  positionStrategy="fixed"
                >
                  <div className="info-button__tooltip-content">Help</div>
                </Tooltip>
              </>
            )}
          />
        </div>
      </div>
    </div>
  );
}
